<script lang="ts">
  import { observe } from "$lib/actions/observe";
  import { sanitizeRich } from "$lib/utils/sanitize";

  let { sectionLabel = "", headline = "", description = "", ctaPrimary = { text: "", href: "#" }, ctaSecondary = { text: "", href: "#" }, codeSnippet = [] as string[] } = $props();
</script>

<section class="hero">
  <div class="container">
    <div class="hero-grid">
      <div class="fade-up" use:observe>
        {#if sectionLabel}
          <span class="section-label">{sectionLabel}</span>
        {/if}
        <h1>{@html sanitizeRich(headline)}</h1>
        <p>{description}</p>
        <div class="hero-actions">
          {#if ctaPrimary.text}
            <a href={ctaPrimary.href} class="btn btn-primary">{ctaPrimary.text}</a>
          {/if}
          {#if ctaSecondary.text}
            <a href={ctaSecondary.href} class="btn btn-outline">{ctaSecondary.text}</a>
          {/if}
        </div>
      </div>
      {#if codeSnippet.length}
        <div class="hero-visual fade-up" use:observe style="transition-delay:.15s">
          <div class="hero-code">
            {#each codeSnippet as line}
              <div>{@html sanitizeRich(line)}</div>
            {/each}
          </div>
        </div>
      {/if}
    </div>
  </div>
</section>
